var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[_c('data-table',{ref:"linkedTb",attrs:{"module-info":_vm.moduleInfo,"tb-columns":_vm.tbColumns,"toolbar-btns":_vm.listpageBtns,"custom-toolbar-btns":null,"on-list-data-before-load":_vm.onListDataBeforeLoad,"on-list-data-loaded":_vm.onListDataLoaded,"on-delete-successed":_vm.onDeleteSuccessed}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }